import { Component } from '@angular/core';

@Component({
  selector: 'pdf-prepare-printing-dialog',
  templateUrl: './pdf-prepare-printing-dialog.component.html',
})
export class PdfPreparePrintingDialogComponent {}
